import YAML from 'yaml';

YAML.scalarOptions.str.fold.lineWidth = 0;

export default YAML;
